<template>
  <router-view
    :closeAuth="closeAuth"
    :code="code"
    :email="email"
    :fetchAccountStatus="fetchAccountStatus"
    :logInWithEmailAndPassword="logInWithEmailAndPassword"
    :password="password"
    :phone="phone"
    :toAuthRoute="toAuthRoute"
    :toLogInRoute="toLogInRoute"
    :update="update"
    :updateCode="updateCode"
    :updatePhone="updatePhone"
  />
</template>

<script>
import { Steps } from "@/types/signup.js";
import { formatPhoneNumber } from "@/util.js";
import { mapGetters, mapState } from "vuex";

export default {
  name: "LogInView",
  computed: {
    ...mapGetters({
      authorized: "auth/isAuthenticated",
      userClickedCartButtonBeforeAuthenticated:
        "cart/userClickedCartButtonBeforeAuthenticated",
    }),
    ...mapState({
      account: (state) => state.auth.account,
      rerouteOrderId: (state) => state.orders.rerouteOrderId,
      showSMSRetryMessage: (state) => state.auth.showSMSRetryMessage,
      user: (state) => state.user.info,
      websiteFormat: (state) =>
        state.store.info.store_info.customization?.website.style
          .website_format ?? "all_items",
    }),
  },
  data() {
    return {
      code: { input0: null, input1: null, input2: null, input3: null },
      email: null,
      password: null,
      phone: null,
    };
  },
  methods: {
    closeAuth() {
      this.$router.push({ name: "terms" });
    },
    async fetch() {
      // don't await
      this.$store.dispatch("orders/fetch");
      this.$store.dispatch("favorites/fetch");

      // await to open cart if products after click on cart and login etc.
      await this.$store.dispatch("cart/fetch");

      /*
      router needs to know if coming from reset
      because then we want to route to home.

      on the other hand, if it's a regular login
      then we just want to go back to the home page
      */

      this.rerouteOrderId ? this.routeToAccount() : this.routeAfterLogin();
    },
    async fetchAccountStatus() {
      this.$store.commit("auth/SHOW_SMS_RETRY_MESSAGE", false);
      const { input0, input1, input2, input3 } = this.code;
      const verificationCode = input0.concat(input1, input2, input3);

      const info = {
        country_code: 1,
        phone: this.phone,
        verification_code: verificationCode,
      };
      await this.$store.dispatch("auth/fetchAccountStatus", info);
      if (this.showSMSRetryMessage) {
        return;
      }

      this.authorized
        ? this.account
          ? this.$router.push({ name: Steps.registration })
          : this.fetch()
        : this.$router.push({ name: Steps.identification });
    },
    async logInWithEmailAndPassword() {
      const info = {
        email: this.email,
        password: this.password,
      };
      await this.$store.dispatch("auth/login", info);
      if (!this.authorized) {
        return;
      }
      this.user.phone
        ? this.fetch()
        : this.$router.push({ name: "identification" });
    },
    routeAfterLogin() {
      this.userClickedCartButtonBeforeAuthenticated
        ? this.$router.push({ name: "cart" })
        : this.websiteFormat === "store_info_rewards"
        ? this.$router.push({
            name: "account",
            hash: "#rewards",
          })
        : this.$router.push({ name: "home" });
    },
    routeToAccount() {
      this.$router.push({
        name: "account",
        hash: "#orders",
        params: { orderId: this.rerouteOrderId },
      });
    },
    toAuthRoute(route) {
      route === "signup"
        ? this.$router.push({ name: "identification" })
        : this.$router.push({ name: route });
    },
    toLogInRoute(route) {
      this.$router.push({ name: route });
    },
    update(name, val) {
      this[name] = val;
    },
    updateCode(input, val) {
      this.code[`input${input}`] = val;
    },
    updatePhone(val) {
      this.phone = formatPhoneNumber(val);
    },
  },
  mounted() {
    this.$store.commit("auth/SHOW_SMS_RETRY_MESSAGE", false);
  },
};
</script>
